module.exports = __webpack_public_path__ + "img/cheque.70703522.jpg";